import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "delivery-item__wrap" };
var _hoisted_2 = { class: "delivery-item__top" };
var _hoisted_3 = { class: "delivery-item__cover" };
var _hoisted_4 = ["src", "alt"];
var _hoisted_5 = { class: "delivery-item__name" };
var _hoisted_6 = { class: "delivery-item__main" };
var _hoisted_7 = { class: "delivery-item__info" };
var _hoisted_8 = {
    key: 0,
    class: "delivery-item__date"
};
var _hoisted_9 = {
    key: 0,
    class: "delivery-item__extra"
};
var _hoisted_10 = {
    key: 0,
    class: "delivery-item__message"
};
var _hoisted_11 = {
    key: 1,
    class: "delivery-item__today"
};
var _hoisted_12 = { class: "form-group" };
var _hoisted_13 = {
    key: 2,
    class: "delivery-item__cost-info"
};
var _hoisted_14 = { class: "notice notice--xs notice--bg notice--gray" };
var _hoisted_15 = {
    key: 0,
    class: "delivery-item__control"
};
var _hoisted_16 = { class: "form-group" };
var _hoisted_17 = { class: "switch radio radio--m" };
var _hoisted_18 = { class: "switch__main" };
var _hoisted_19 = ["value", "disabled"];
var _hoisted_20 = { class: "switch__cover radio__cover" };
import Sprite from "../Sprite.vue";
import { computed, watch } from "vue";
import Checkbox from "../Checkbox.vue";
import TextPreloader from "../TextPreloader.vue";
import Price from "../Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryAddress',
    props: /*@__PURE__*/ _mergeModels({
        address: { type: Object, required: true },
        delivery: { type: Object },
        available: { type: Boolean, default: true },
        bordered: Boolean,
        freeAmount: Number,
        loading: Boolean,
        sameDayPrice: Number,
        radio: Boolean,
        sameDayDeliveryAvailable: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "same-day": {},
        "same-dayModifiers": {},
    }),
    emits: ["update:modelValue", "update:same-day"],
    setup: function (__props) {
        var props = __props;
        var value = _useModel(__props, "modelValue");
        var sameDayDelivery = _useModel(__props, 'same-day');
        var isSameDayAvailable = computed(function () { return !props.loading && props.available && props.sameDayDeliveryAvailable && props.address.delivery.name === 'courier'; });
        var isSameDay = computed(function () { return isSameDayAvailable.value && sameDayDelivery.value; });
        var imgSrc = computed(function () { return "/img/delivery-".concat(isSameDay.value ? 'courier-fast' : props.address.delivery.icon, "-sm.svg"); });
        var addressLine = computed(function () {
            return props.address.delivery.name === 'fivepost' ? "".concat(props.address.fullAddress, ", ").concat(props.address.directions) : props.address.fullAddress;
        });
        var deliveryDate = computed(function () {
            var _a;
            if (!props.delivery) {
                return '';
            }
            return (_a = props.delivery.date) !== null && _a !== void 0 ? _a : '';
        });
        watch(function () { return props.address.delivery.name; }, function (value) {
            if (value !== 'courier' && !props.loading) {
                sameDayDelivery.value = false;
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["delivery-item", { 'delivery-item--bordered': __props.bordered, 'delivery-item--na': !__props.available }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: imgSrc.value,
                                width: "40",
                                height: "24",
                                alt: __props.address.delivery.title
                            }, null, 8 /* PROPS */, _hoisted_4)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(isSameDay.value ? "\u041A\u0443\u0440\u044C\u0435\u0440\u043E\u043C \u0434\u043E \u0434\u0432\u0435\u0440\u0438 \u0441\u0435\u0433\u043E\u0434\u043D\u044F (+".concat(__props.sameDayPrice, "\u202F\u20BD)") : __props.address.delivery.title) + " ", 1 /* TEXT */),
                            (__props.loading)
                                ? (_openBlock(), _createBlock(TextPreloader, { key: 0 }))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(addressLine.value), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (deliveryDate.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _cache[3] || (_cache[3] = _createTextVNode("Доставка ", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(deliveryDate.value), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    (isSameDayAvailable.value || (!__props.available && !__props.loading) || __props.freeAmount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (!__props.available && !__props.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Этот способ доставки больше не доступен. Выберите другой"))
                                : _createCommentVNode("v-if", true),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            (isSameDayAvailable.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(Checkbox, {
                                            name: "same_day",
                                            modifier: "s",
                                            label: "\u0414\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0435\u0433\u043E\u0434\u043D\u044F (+".concat(__props.sameDayPrice, "\u202F\u20BD)"),
                                            disabled: !__props.available,
                                            modelValue: sameDayDelivery.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((sameDayDelivery).value = $event); })
                                        }, null, 8 /* PROPS */, ["label", "disabled", "modelValue"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            (__props.freeAmount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[6] || (_cache[6] = _createTextVNode("\n            Закажите ещё на ", -1 /* CACHED */)),
                                        _createElementVNode("strong", null, [
                                            _createVNode(Price, { amount: __props.freeAmount }, null, 8 /* PROPS */, ["amount"]),
                                            _cache[5] || (_cache[5] = _createTextVNode("\n            и доставка будет бесплатной", -1 /* CACHED */))
                                        ]),
                                        _cache[7] || (_cache[7] = _createTextVNode("!\n          ", -1 /* CACHED */))
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                (__props.radio)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("label", _hoisted_18, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        class: "switch__input",
                                        name: "address",
                                        value: __props.address.id,
                                        disabled: !__props.available,
                                        required: "",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((value).value = $event); })
                                    }, null, 8 /* PROPS */, _hoisted_19), [
                                        [_vModelRadio, value.value]
                                    ]),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_20, [
                                        _createVNode(Sprite, { name: "check" })
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "controls")
            ], 2 /* CLASS */));
        };
    }
});
